module.exports = __webpack_public_path__ + "static/a-mother-holding-an-infant.3cea1138.webp";